import repository from "@/plugins/axios/secureClient";
import { DownloadFile } from "@/utils/LoadFile.js";

const resource = "/crm-contacts";

export default {
  getList(params) {
    return repository.get(`${resource}/`, { params });
  },
  getOne(id) {
    return repository.get(`${resource}/${id}`);
  },
  getCreateTemplate() {
    return repository.get(`${resource}/new`);
  },
  create(payload) {
    return repository.post(`${resource}/`, payload);
  },
  update(id, payload) {
    return repository.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return repository.delete(`${resource}/${id}`);
  },
  exportCrm(params, onDownloadProgress) {
    return DownloadFile(`${resource}/export`, "GET", {
      params,
      onDownloadProgress
    });
  },
  massUpdate(payload, tagname) {
    return repository.put(`${resource}/mass-update-${tagname}`, payload);
  }
};
